import React from "react";
import ReactDatePicker from "react-datepicker";
import { connect } from "formik";
import "react-datepicker/dist/react-datepicker.css";
import { StyledDatePicker, Header, MonthAndYear, CustomDay } from "./styles";
import Card from "components/card";
import { ReactComponent as Chevron } from "assets/images/chevron-down-icon.svg";
import months from "utils/months";
import { string, instanceOf, func, bool } from "prop-types";
import { Error } from "components/shared/form";
import Label from "components/label";

const calendarContainer = ({ className, children }) => {
  return (
    <Card style={{ padding: 20 }}>
      <div className={className}>
        <div style={{ position: "relative" }}>{children}</div>
      </div>
    </Card>
  );
};

const DatePicker = ({
  placeholder,
  label,
  name,
  formik,
  value = formik.values[name],
  onChange = (val) => formik.setFieldValue(name, val, true),
  onBlur = () => formik.setFieldTouched(name, true, true),
  disabled,
  isDateRange,
  startDate = formik.values.startDate,
  endDate = formik.values.endDate,
}) => {
  const customDay = (day) => <CustomDay>{day}</CustomDay>;
  const rangeData = isDateRange
    ? {
        startDate,
        endDate,
      }
    : {};

  /**
   * Blur to run after onChange for validations to be correct.
   */
  const delayedBlur = () =>
    setTimeout(() => {
      onBlur();
    }, 5);

  const { errors, touched, values } = formik;
  const validRange = startDate <= endDate;
  return (
    <StyledDatePicker validRange={validRange} populated={!!value}>
      <Label visible={values[name]} label={label || placeholder} />
      <ReactDatePicker
        renderCustomHeader={({ date, decreaseMonth, increaseMonth }) => (
          <Header>
            <Chevron onClick={decreaseMonth} />
            <MonthAndYear>
              {months[date.getMonth()]} <span>{date.getFullYear()}</span>
            </MonthAndYear>
            <Chevron onClick={increaseMonth} />
          </Header>
        )}
        placeholderText={placeholder}
        name={name}
        selected={value}
        onSelect={delayedBlur}
        onBlur={delayedBlur}
        onChange={onChange}
        dateFormat="dd MMM yyyy"
        calendarContainer={calendarContainer}
        renderDayContents={customDay}
        {...rangeData}
        disabled={disabled}
        autoComplete="off"
      />
      {errors[name] && touched[name] && <Error>{errors[name]}</Error>}
    </StyledDatePicker>
  );
};

export default connect(DatePicker);

DatePicker.defaultProps = {
  placeholder: "",
  label: "",
  disabled: false,
  isDateRange: false,
};

DatePicker.propTypes = {
  placeholder: string,
  label: string,
  name: string.isRequired,
  value: instanceOf(Date),
  onChange: func,
  startDate: instanceOf(Date),
  endDate: instanceOf(Date),
  disabled: bool,
  isDateRange: bool,
};
